import script from "./ColumnHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColumnHeader.vue?vue&type=script&lang=ts&setup=true"

import "./ColumnHeader.vue?vue&type=style&index=0&id=e0e02f00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0e02f00"]])

export default __exports__